import moment from 'moment';
import { defineComponent, ref } from 'vue';
export default defineComponent({
  name: 'LoginDialog',
  props: {
    showFlag: {
      type: Boolean,
      default: false
    }
  },
  setup: function (props, _a) {
    var emit = _a.emit;
    var showCloseIcon = ref(false);
    var showQrcodeStatus = ref(false);
    var disagree = function () {
      emit('close');
      window.hetaoTrack('chongqin_active_btn_event', {
        type: '不同意',
        submitTime: moment().format('YYYY-MM-DD HH:mm:ss')
      });
    };
    var showCode = function () {
      showCloseIcon.value = true;
      showQrcodeStatus.value = true;
      window.hetaoTrack('chongqin_active_btn_event', {
        type: '同意',
        submitTime: moment().format('YYYY-MM-DD HH:mm:ss')
      });
    };
    var cancel = function () {
      showCloseIcon.value = false;
      showQrcodeStatus.value = false;
      emit('close');
    };
    return {
      showCloseIcon: showCloseIcon,
      showQrcodeStatus: showQrcodeStatus,
      disagree: disagree,
      showCode: showCode,
      cancel: cancel
    };
  }
});